import { type FC, useContext } from "react";
import { DragDropEditorContext, type DragDropSettingsProps } from "../../../Forms/DragDrop/DragDropTypes";
import { hasColumnsValue, ReorderableTableSettings } from "../../../Forms/DragDrop/ReorderableTableSettings";

const COLUMN_DEFINITIONS = {
    "start-balance"  : "Start balance",
    "end-balance"    : "End balance",
    "changed-balance": "Balance changed",
    "current-balance": "Current Balance",
};

export const ReceiptAccountTableSettings: FC<DragDropSettingsProps> = ({
    id,
    value,
}) => {
    const { manager } = useContext(DragDropEditorContext);

    const columns = hasColumnsValue(value) ? value.columns : [];

    return (
        <ReorderableTableSettings
            value={columns}
            onChange={columns => {
                manager.updateComponent(id, {
                    ...(hasColumnsValue(value) ? value : {}),
                    columns,
                });
            }}
            renameable
            columns={COLUMN_DEFINITIONS}
        />
    );
};
